import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

interface UnderConstructionProps {
  title?: string;
  message?: string;
}

const UnderConstruction: React.FC<UnderConstructionProps> = ({
  title = "Under Construction",
  message = "This feature is currently being developed and will be available soon."
}) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-2xl w-full">
        <CardHeader>
          <div className="flex flex-col items-center gap-4">
            <div className="text-6xl">🚧</div>
            <CardTitle className="text-2xl text-center">{title}</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-center space-y-4">
            <p className="text-gray-600 text-lg">
              {message}
            </p>
            <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
              <div className="animate-pulse">⚡</div>
              <span>Working on it...</span>
              <div className="animate-pulse">⚡</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UnderConstruction;
